import TncPage from "@/components/tnc/TncPage";
import {
  mecturingTncFooterNote,
  mecturingTncHero,
  mecturingTncSections,
} from "./tncContent";

export default function MecturingTnc() {
  return (
    <TncPage
      hero={mecturingTncHero}
      sections={mecturingTncSections}
      footerNote={mecturingTncFooterNote}
      path="/mecturing-productprotection/tnc"
    />
  );
}
